export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14678.9f2270eb.jpg";